const TOAST_MESSAGES = {
  approve_success: 'successfully approved {{name}}',
  deny_success: 'successfully denied {{name}}',
  cancel_success: 'successfully cancelled {{name}}',
  create_success: 'successfully created {{name}}',
  update_success: 'successfully updated {{name}}',
  revoke_success: 'successfully revoked {{name}}',
  remove_success: 'successfully removed {{name}}',
  save_success: 'successfully saved {{name}}',
  delete_success: 'successfully deleted {{name}}',
  send_success: 'successfully sent {{name}} to {{email}}',
  invite_success: 'invitation sent to {{email}}',
  refund_success: 'successfully refunded payment',
  import_success: 'successfully imported {{name}}',
  import_partial_success:
    '{{successCount}} of {{totalCount}} {{name}} were created.  Please review the failed {{name}} and resubmit them.',
  approve_all_success: 'successfully approved all {{name}}',
  approve_all_partial_success:
    '{{successCount}} of {{totalCount}} {{name}} were approved.  Please review the failed {{name}} individually.',
  combine_accounts_success: 'successfully combined accounts',
  combine_accounts_error: 'could not combine accounts: {{error}}',
  approve_error: 'could not approve {{name}}: {{error}}',
  deny_error: 'could not deny {{name}}: {{error}}',
  cancel_error: 'could not cancel {{name}}: {{error}}',
  create_error: 'could not create {{name}}: {{error}}',
  update_error: 'could not update {{name}}: {{error}}',
  revoke_error: 'failed to revoke {{name}}: {{error}}',
  remove_error: 'failed to remove {{name}}: {{error}}',
  send_error: 'could not send {{name}}: {{error}}',
  reset_password_error: 'could not reset password: {{error}}',
  save_error: 'could not save {{name}}: {{error}}',
  delete_error: 'could not delete {{name}}: {{error}}',
  find_error: 'could not find {{name}}: {{error}}',
  import_error: 'could not import {{name}}: {{error}}',
  item_added: '{{name}} added to {{list}}: {{error}}',
  item_removed: '{{name}} removed from {{list}}: {{error}}',
  add_item_fail: 'could not add {{name}} to {{list}}',
  remove_item_fail: 'could not remove {{name}} from {{list}}',
  refund_error: 'could not refund payment: {{error}}',
  registration_sent: 'registration email sent to {{email}}',
  reset_password_sent: 'password reset email sent to {{email}}',
  api_key_copied: 'API key copied to clipboard',
  brand_url_copied: 'brand URL copied to clipboard',
  unknown_error: 'an unknown error occurred',
  user_already_exists:
    'a user with this email address already exists.  Please use a different email address.',
  unauthorized:
    'you are not authorized to access that page.  If you need access, please contact your administrator.',
  expired_token: 'your session has expired.  Please log in again.',
  invalid_token: 'your session is invalid.  Please log in again.',
  not_found:
    'the page you are looking for does not exist.  Please check the URL and try again.',
  duplicate_dnt_error:
    'an active Do Not Tow already exists for this plate with an overlapping time range.  Please check the entry and try again.',
};

export default TOAST_MESSAGES;
